const stats = [
  { value: '13+', label: 'Years of enterprise experience' },
  { value: 'AI-first', label: 'Per-project AI tooling', small: true },
  { value: '10', label: 'Active certifications' },
];

export default function Stats() {
  return (
    <section className="stats-section">
      <div className="stats-inner">
        {stats.map((stat, i) => (
          <div key={i} className="stat-item">
            <span className={`stat-value${stat.small ? ' stat-value-word' : ''}`}>{stat.value}</span>
            <span className="stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
